import { useMemo } from "react";
import { IDatabaseLineItem } from "../pages/CreatorTools/LineItemDBCreationToolPage";
import { ScopeTag } from "../pages/CreatorTools/MappingTool/utils/ScopeTag";
import { useFirestoreCollectionReadWrite } from "./useFirestoreCollectionReadWrite";

export const useLineItemTemplates = () => {
  const { objects: _dbLineItems, isLoading } = useFirestoreCollectionReadWrite<IDatabaseLineItem>("tools", { idField: "id" });

  const dbLineItemsFiltered = useMemo(() => {
    if (isLoading) {
      return [];
    }
    return _dbLineItems.filter((dbLineItem) => {
      const isDeleted = dbLineItem.deleted;
      const isDraftTemplate = dbLineItem.scopes?.length === 1 && dbLineItem.scopes?.includes(ScopeTag.DRAFT);
      return !isDeleted && !isDraftTemplate;
    });
  }, [isLoading, _dbLineItems]);

  return { isLoading, dbLineItems: dbLineItemsFiltered };
};
